import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedFilterIds,
  handleSetSelectedItems,
  handleSetSelectedFilterValue,
  handleToggleCollapsed,
  handleSetSelectedSentimentValues,
  handleSetSelectedContentBasedValues,
  handleSetSelectedCategories,
  handleSetAdvertFilterValues,
  handleChangeSortBy,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './contentHelpers';
import { virastyFiltersInitialState } from './initialState/virastyInitialState';

export { virastyFiltersInitialState as filtersInitialState };
export const virastyContentInitialState = {
  filters: virastyFiltersInitialState,
  sortBy: {
    selected: 'time',
    order: 'desc',
  },
  selectedFilter: 'contentTagFilter',
};
export const virastyContentSlice = createSlice({
  name: 'virastyContentSlice',
  initialState: virastyContentInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedItems: (state, action) => {
      handleSetSelectedItems(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(state, action, virastyFiltersInitialState);
    },
    setSelectedSentimentValues: (state, action) => {
      handleSetSelectedSentimentValues(state, action);
    },
    setSelectedContentBasedValues: (state, action) => {
      handleSetSelectedContentBasedValues(state, action);
    },
    setAdvertFilterValues: (state, action) => {
      handleSetAdvertFilterValues(state, action);
    },
    setSelectedCategories: (state, action) => {
      handleSetSelectedCategories(state, action);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = virastyFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, virastyFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  setSelectedItems,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedFilterValue,
  setSelectedCategories,
  setSelectedSentimentValues,
  setAdvertFilterValues,
  setSelectedContentBasedValues,
  changeSortBy,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
} = virastyContentSlice.actions;
